import { Link } from "react-router";
import { useIntl } from "react-intl";
import type { TobisTitle } from "@/lib/tobis";
import { TobisTitleCover } from "./TobisTitleCard";

// Kompakte Zeile fuer die Kompakt-Ansicht: kleines Poster statt der grossen
// Kachel, damit ein Bestand von hunderten Titeln (nach einem Backfill-Lauf)
// sich durchscrollen laesst, ohne dass jede Kachel einen ganzen Bildschirm
// Hoehe braucht. Gleiches Zeilen-Muster wie TobisPersonRow (Bild links, Text
// rechts), damit Kacheln/Kompakt auf Titel- und Personen-Seite gleich wirken.

export function TobisTitleRow({ title, index = 0 }: { title: TobisTitle; index?: number }) {
  const intl = useIntl();
  const year = title.year === null ? "" : String(title.year);
  const votes = title.imdbVotes ? Number(title.imdbVotes) : null;

  const meta = [
    year,
    title.genres[0],
    title.admissionsDe
      ? intl.formatMessage(
          { id: "tobis.card.admissionsDe", defaultMessage: "{count} DE" },
          { count: intl.formatNumber(Number(title.admissionsDe), { notation: "compact" }) },
        )
      : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <Link
      to={`/tobis/titles/${title.id}`}
      className="group flex items-center gap-3 rounded-md bg-surface box p-2 transition hover:ring-accent/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-ink/30"
    >
      <div className="relative aspect-[2/3] h-14 shrink-0 overflow-hidden rounded">
        <TobisTitleCover title={title} index={index} />
      </div>

      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="truncate text-[13px] font-medium text-ink/80 transition group-hover:text-accent">
            {title.name}
          </span>
          {title.kind ? (
            <span className="shrink-0 rounded bg-accent px-1.5 py-0.5 text-[9px] tracking-widest text-on-accent">
              {title.kind}
            </span>
          ) : null}
        </div>
        {meta ? <div className="truncate text-[12px] text-ink/45">{meta}</div> : null}
      </div>

      <span className="shrink-0 text-[12px] tabular-nums text-ink/45">
        {title.imdbRating
          ? intl.formatMessage(
              { id: "tobis.card.rating", defaultMessage: "{rating} ({votes})" },
              {
                rating: title.imdbRating,
                votes: votes === null ? "" : intl.formatNumber(votes, { notation: "compact" }),
              },
            )
          : intl.formatMessage({ id: "tobis.card.noRating", defaultMessage: "no rating" })}
      </span>
    </Link>
  );
}
